import React, { Component } from 'react';
import './Table.css';

class Loader extends Component {
    // headers = ['head1','head2']
    // items = [[{text:'text',callback:function(){}, align=''},{text:'text',callback:function(){}, align="left"}]]
    render() {
        var width = [];
        var align = [];
        var emptyHeader = true;
        this.props.data.headers.forEach(header => {
            width.push(header.width);
            var a = "left";
            if(header.align !== undefined){
                a = header.align;
            }
            align.push(a);
            if(header.text !== null && header.text !== undefined){
                emptyHeader = false;
            }
        });
        return ( 
            <div className="table">
                {emptyHeader === false &&
                    <div className="table-headers">
                        {this.props.headers !== null && this.props.data.headers.map((item,i)=>(
                                <div className="table-header" key={"header" + i} style={{textAlign:align[i],width:width[i]}}>
                                    <div className="table-header-element">{item.text}</div>
                                </div>
                        ))}
                    </div>
                }
                {emptyHeader === true &&
                    <div className="table-emtyheader"></div>
                }
                {this.props.data.items.map((item,i)=>
                    <div className="table-item" key={"table" + i}>
                        {item.map((value,j)=>{
                            if(value.callback !== undefined){
                                return(<button type="button" className="table-value-active" key={"value" + j} style={{textAlign:align[j],width:width[j]}} onClick={()=>{value.callback()}}>
                                    <div className="table-element">{value.text}</div>
                                </button>);
                            } else {
                                return(<div className="table-value" key={"value" + j} style={{textAlign:align[j],width:width[j]}}>
                                    <div className="table-element">{value.text}</div>
                                </div>);
                            }
                        })}
                    </div>
                )}
            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Table/Table.js